import { dateLib } from "@agentcall/core/lib"
import { RefreshCw } from "react-feather"

interface Props {
  /** Echoes 側の ID 項目名（例: Echoes建物ID） */
  idLabel: string
  echoesId: string | null | undefined
  echoesUpdatedAt: string | null | undefined
  echoesFailedAt: string | null | undefined
}

/** Echoes から同期されたレコードの連携情報カード。未連携のレコードでは何も表示しない。 */
export const EchoesSyncCard = ({ idLabel, echoesId, echoesUpdatedAt, echoesFailedAt }: Props) => {
  if (!echoesId && !echoesUpdatedAt && !echoesFailedAt) return null

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="flex items-center gap-1.5 px-5 py-2.5 border-b border-slate-200">
        <RefreshCw size={14} />
        <span className="text-sm font-semibold text-slate-600">Echoes連携</span>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-7 gap-x-7.5 gap-y-4">
          <div>
            <div className="text-xs font-medium text-slate-400 mb-2">{idLabel}</div>
            <div className="text-sm text-slate-600">{echoesId ?? "-"}</div>
          </div>
          <div>
            <div className="text-xs font-medium text-slate-400 mb-2">最終同期日時</div>
            <div className="text-sm text-slate-600">
              {echoesUpdatedAt ? dateLib.formatDateTime(echoesUpdatedAt) : "-"}
            </div>
          </div>
          <div>
            <div className="text-xs font-medium text-slate-400 mb-2">同期失敗日時</div>
            <div className={`text-sm ${echoesFailedAt ? "text-red-600" : "text-slate-600"}`}>
              {echoesFailedAt ? dateLib.formatDateTime(echoesFailedAt) : "-"}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

/** 一覧テーブル用。Echoes側IDを表示し、同期失敗中なら赤字で添える。未連携は「-」。 */
export const EchoesSyncCell = ({
  echoesId,
  echoesFailedAt,
}: Pick<Props, "echoesId" | "echoesFailedAt">) => (
  <span className="whitespace-nowrap">
    {echoesId ?? "-"}
    {echoesFailedAt && <span className="ml-1 text-xs text-red-600">同期失敗</span>}
  </span>
)

/** 一覧検索フォームの Echoes 連携有無フィルタ。値は URL クエリにそのまま載せる。 */
export const echoesLinkedFilterValues = ["all", "true", "false"] as const
export type EchoesLinkedFilterValue = (typeof echoesLinkedFilterValues)[number]
export const echoesLinkedFilterOptions = [
  { value: "all", label: "すべて" },
  { value: "true", label: "あり" },
  { value: "false", label: "なし" },
]
export const normalizeEchoesLinkedFilter = (
  value: string | null | undefined
): EchoesLinkedFilterValue => (value === "true" || value === "false" ? value : "all")
